import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TabViewModule } from 'primeng/primeng';
import { FieldsetModule } from 'primeng/primeng';
import { MenuItem } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';
import { PadraoService } from '../../service/padrao.service';
import { Message } from 'primeng/primeng';

import { BaseCrudComponent } from "../../base/base-crud.component";

@Component({
  selector: 'funcionalidade-acao-crud',
  templateUrl: 'funcionalidade-acao-crud.component.html'
})

export class CrudFuncionalidadeAcaoCrudComponent extends BaseCrudComponent {
  controllerName = 'funcionalidadeAcao';
  selectedValue: string = 'Ativo';
  
  etapas:MenuItem[] = [
    {label: 'Dados'}
  ];

  //Sistemas
  SistemaOptions: SelectItem[] = [];
  SistemaSelecionado: string[] = [];

  //Perfil
  PerfilOptions: SelectItem[] = [];
  PerfilSelecionado: string[] = [];

  //Funcionalidade
  FuncionalidadeOptions: SelectItem[] = [];
  FuncionalidadeSelecionada: string[] = [];

  //Ação
  AcaoOptions: SelectItem[] = [];
  AcaoSelecionada: string[] = [];

  init() {
    this.cadastro = this.formBuilder.group({
      id_sistema: [null, [Validators.required]],
      id_acao: [null, [Validators.required]],
      id_Perfil: [null, [Validators.required]],
      id_funcionalidade: [null],
      situacao: [null, [Validators.required]],
      id: [null]
    });

    this.service.ListarTodos('sistema', 'Sistemas').subscribe(
      data => { data.forEach(element => { this.SistemaOptions.push({ label: element.nome, value: element.id }); }); }
    );

    this.service.ListarTodos('perfil', 'Perfil').subscribe(
      data => { data.forEach(element => { this.PerfilOptions.push({ label: element.nome, value: element.id }); }); }
    );

    this.service.ListarTodos('funcionalidade', 'Funcionalidades').subscribe(
      data => { data.forEach(element => { this.FuncionalidadeOptions.push({ label: element.nome, value: element.id }); }); }
    );

    this.service.ListarTodos('acao', 'Ação').subscribe(
      data => { data.forEach(element => { this.AcaoOptions.push({ label: element.nome, value: element.id }); }); }
    );
  }

  finalizar(event: any) {
    var dados: any = [];

    this.AcaoSelecionada.forEach(i => {
      dados.push({ id: null, id_unidade: i, id_usuario: null });
    });

    this.cadastro.value.unidade_usuario = dados;
  }

  sair(){
    this.router.navigate(['../'], { relativeTo: this.activatedRoute });
  }
}


// WEBPACK FOOTER //
// ./src/app/funcionalidade-acao/crud/funcionalidade-acao-crud.component.ts